export default __webpack_public_path__ + "static/media/bellamare7.8525caa3.jpg";